import React, { useState, useEffect, useMemo } from "react";
import "../../assets/css/data-table.css";
import Swal from "sweetalert2";
import {
  Card,
  CardBody,
  Button,
  Input,
  FormGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import DataTable from "react-data-table-component";
import DataTableSettings from "../../utils/DataTableSettings";
import { TemplateSizeForm, BreadCrumb } from "../../config/Components";
import { API_TEMPLATE_SIZE } from "../../config/Api";

const TemplateSizeList = (props) => {
  const { className } = props;
  const [modal, setModal] = useState(false);
  const [templateSizeId, setTemplateSizeId] = useState(0);
  const toggle = () => {
    setModal(!modal);
    setTemplateSizeId(0);
  };
  const [template_sizes, setTemplateSizes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const searchParam = ["size_name", "width", "height"];

  useEffect(() => {
    fetchTemplateSize();
  }, []);

  const fetchTemplateSize = async () => {
    props.callRequest("GET", API_TEMPLATE_SIZE, true).then((res) => {
      setTemplateSizes(res.data);
      setLoading(false);
    });
  };

  const columns = [
    {
      name: "Size Name",
      selector: "size_name",
      sortable: true,
    },
    {
      name: "Width",
      selector: "width",
      sortable: true,
    },
    {
      name: "Height",
      selector: "height",
      sortable: true,
    },
    {
      name: "Actions",
      selector: "size_id",
      sortable: false,
      cell: (row) => (
        <UncontrolledDropdown>
          <DropdownToggle>
            <i className="fas fa-ellipsis-v"></i>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => editTemplateSize(row.size_id)}>
              Edit
            </DropdownItem>
            <DropdownItem onClick={() => onDelete(row.size_id)}>
              Delete
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      ),
    },
  ];

  const editTemplateSize = (size_id) => {
    toggle();
    setTemplateSizeId(size_id);
  };

  const onDelete = (size_id) => {
    Swal.fire({
      icon: "question",
      title: "Do you want to delete?",
      showDenyButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `Cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        props
          .callRequest("DELETE", API_TEMPLATE_SIZE + size_id, true)
          .then((res) => {
            if (res.status) {
              Swal.fire("Deleted!", "", "success");
              fetchTemplateSize();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <FormGroup>
        <Input
          id="search"
          type="text"
          placeholder="Search"
          aria-label="Search Input"
          value={filterText}
          autoComplete="off"
          onChange={(e) => setFilterText(e.target.value)}
        />
      </FormGroup>
    );
  }, [filterText]);

  const Export = ({ onExport }) => (
    <div className="right-button-block">
      <Button onClick={toggle}>
        <i className="ni ni-fat-add"></i> Add Size
      </Button>
      {/* <UncontrolledDropdown>
        <DropdownToggle caret>
          <i className="bi-filter"></i> Filter
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem>Filter Name 1</DropdownItem>
          <DropdownItem>Filter Name 2</DropdownItem>
          <DropdownItem>Filter Name 3</DropdownItem>
          <DropdownItem>Filter Name 4</DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
      <Button><i className="bi-pencil-square"></i> Edit Columns</Button> */}
      {/* <Button
        disabled={template_sizes.length > 0 ? false : true}
        onClick={(e) => onExport(e.target.value)}
      >
        <i className="ni ni-ungroup"></i> Export
      </Button> */}
    </div>
  );

  const export_column = ["size_name", "width", "height"];

  const actionsExport = useMemo(
    () => (
      <Export
        onExport={() =>
          DataTableSettings.downloadCSV(
            template_sizes,
            export_column,
            props.generateUniqueId()
          )
        }
      />
    ),
    [template_sizes]
  );

  return (
    <>
      <main role="main" className="pt-3 px-4">
        <div className="main-heading-block">
          <BreadCrumb links={["Template Size", "Template Size List"]} />
          <h1 className="header-title">
            <span className="header-icon">
              <i className="ni ni-bag-17"></i>
            </span>
            Template Size List
          </h1>
        </div>

        <div className="listingtable-main-block">
          <Card>
            <CardBody>
              <Modal isOpen={modal} toggle={toggle} className={className}>
                {templateSizeId === 0 ? (
                  <ModalHeader toggle={toggle}>Add Size</ModalHeader>
                ) : (
                  <ModalHeader toggle={toggle}>Edit Size</ModalHeader>
                )}
                <ModalBody>
                  <TemplateSizeForm
                    {...props}
                    modalToggle={toggle}
                    fetchTemplateSize={fetchTemplateSize}
                    templateSizeId={templateSizeId}
                  />
                </ModalBody>
              </Modal>

              <div className="list-filtered-table-block">
                {loading === true ? <h3>Loading...</h3> : null}
                {loading === false ? (
                  <DataTable
                    columns={columns}
                    data={DataTableSettings.filterItems(
                      template_sizes,
                      searchParam,
                      filterText
                    )}
                    pagination
                    paginationPerPage={DataTableSettings.paginationPerPage}
                    paginationRowsPerPageOptions={
                      DataTableSettings.paginationRowsPerPageOptions
                    }
                    actions={actionsExport}
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                    persistTableHead
                  />
                ) : null}
              </div>
            </CardBody>
          </Card>
        </div>
      </main>
    </>
  );
};

export default TemplateSizeList;
